/**
 * resource name of endpoint api
 */
const API_USER_RESOURCE: string = 'users';
const API_ARTICLE_RESOURCE: string = 'articles';
const API_FOLDER_RESOURCE: string = 'folders';
const API_CATEGORY_RESOURCE: string = 'categories';
const API_NEEDS_RESOURCE: string = 'needs';
const API_TONE_RESOURCE: string = 'tones';
const API_NEWSLETTER_RESOURCE: string = 'newsletters';
const API_ISSUE_RESOURCE: string = 'issues';
const API_PRODUCT_RESOURCE: string = 'products';
const API_WBCOIN_RESOURCE: string = 'wb_coin';
const API_WALLET_RESOURCE: string = 'wallet';
const API_TASK_RESOURCE: string = 'tasks';
const API_ZIPCODE_RESOURCE: string = 'zipcodes';
const API_QUEUE_RESOURCE: string = 'queues';
const API_NFT_RESOURCE: string = 'nft';
const ARTICLE_RELATION_CACHE_KEY: string = 'article_relations_cache';

/**
 * wordpress error page url
 */
const RESOURCE_LOGIN_WP_ERR_403: string = 'login?error=403';
const RESOURCE_LOGIN_WP_ERR_500: string = 'login?error=500';

/**
 * default page title
 */
const DEFAULT_TITLE: string = 'ダッシュボード';

/**
 * timeout for all request
 */
const TIME_OUT_AXIOS: number = 30000;

/**
 * article status list
 */
const ALL_STATUSES: { id: string; title: string }[] = [
  {
    id: 'draft',
    title: '下書き',
  },
  {
    id: 'reserved',
    title: '予約済み',
  },
  {
    id: 'published',
    title: '公開済み',
  },
];

/**
 * Issue status list
 */
const ISSUE_STATUS_LIST = [
  {
    id: 'draft',
    title: '下書き',
  },
  {
    id: 'reserved',
    title: '予約済み',
  },
  {
    id: 'published',
    title: '配信済み',
  },
  {
    id: 'publishing',
    title: '配信中',
  },
];

/**
 * newsletter status list
 */
const PUBLISH_DRAFT_STATUSES: { id: string; title: string }[] = [
  {
    id: 'draft',
    title: '下書き',
  },
  {
    id: 'published',
    title: '公開済み',
  },
];

const TYPE_DOWNLOAD = [
  {
    id: 'plaintext',
    title: 'プレーンテキスト',
  },
  {
    id: 'html',
    title: 'HTML',
  },
];

const SOCIAL_NETWORK = [
  {
    id: 'facebook',
    title: 'Facebook',
  },
];

const PERMISSION_FACEBOOK = [
  'pages_manage_engagement',
  'pages_manage_metadata',
  'pages_manage_posts',
  'pages_read_user_content',
  'pages_read_engagement',
  'pages_show_list',
];

const VERSION_GRAPH_API = 'v18.0';

const TIME_OUT_STRIPE = 1000;

const STATUS_TASK = [
  {
    id: 0,
    title: '完了タスクを含む',
  },
  {
    id: 1,
    title: '完了タスクを含まない',
  },
];

const TASK_SITUATION_CREATE = [
  {
    id: 'draft',
    title: '下書き',
  },
  {
    id: 'pending',
    title: '依頼中',
  },
];

const TASK_SITUATION_EDIT = [
  {
    id: 'draft',
    title: '下書き',
  },
  {
    id: 'pending',
    title: '依頼中',
  },
  {
    id: 'in_progress',
    title: '作業中',
  },
  {
    id: 'completed',
    title: '完了',
  },
];

const MEMBER_STATUS = [
  {
    id: 'invited',
    title: '招待中',
  },
  {
    id: 'approved',
    title: '招待済み',
  },
];

const ROLE_NONE = 'role_none';

const ROLES_ORDER = ['publisher', 'chief_editor', 'editor', 'writer', 'proofreader', 'role_none'];

const ROLES_USER = [
  {
    id: 'publisher',
    title: '発行者',
  },
  {
    id: 'editor',
    title: '編集者',
  },
  {
    id: 'writer',
    title: 'ライター',
  },
  {
    id: 'chief_editor',
    title: '編集長',
  },
  {
    id: 'proofreader',
    title: '校正者',
  },
];

const PAID_FREE = [
  { id: 1, value: 'FREE', label: '無料' },
  { id: 2, value: 'NORMAL', label: '有料' },
  { id: 3, value: 'DONATION', label: '寄付' },
  { id: 4, value: 'TIP', label: '投げ銭' },
];

const CREATIVE_COMMONS = [
  { id: '', title: '適用しない' },
  { id: 'CC0', title: 'パブリックドメイン' },
  { id: 'BY', title: '表示' },
  { id: 'BY_SA', title: '表示・継承' },
  { id: 'BY_ND', title: '表示・改変禁止' },
  { id: 'BY_NC', title: '表示・非営利' },
  { id: 'BY_NC_SA', title: '表示・非営利・継承' },
  { id: 'BY_NC_ND', title: '表示・非営利・改変禁止' },
];

const DISPLAY_ADS_OPTION = [
  { id: 1, value: false, label: '非表示' },
  { id: 2, value: true, label: '表示' },
];

const NFT_OPTION = [
  { id: 1, value: false, label: 'しない' },
  { id: 2, value: true, label: 'する' },
];

const PREF_WITH_TITLE = [
  { id: '北海道', title: '北海道' },
  { id: '青森県', title: '青森県' },
  { id: '岩手県', title: '岩手県' },
  { id: '宮城県', title: '宮城県' },
  { id: '山形県', title: '山形県' },
  { id: '秋田県', title: '秋田県' },
  { id: '福島県', title: '福島県' },
  { id: '茨城県', title: '茨城県' },
  { id: '栃木県', title: '栃木県' },
  { id: '群馬県', title: '群馬県' },
  { id: '埼玉県', title: '埼玉県' },
  { id: '千葉県', title: '千葉県' },
  { id: '東京都', title: '東京都' },
  { id: '神奈川県', title: '神奈川県' },
  { id: '新潟県', title: '新潟県' },
  { id: '富山県', title: '富山県' },
  { id: '石川県', title: '石川県' },
  { id: '福井県', title: '福井県' },
  { id: '山梨県', title: '山梨県' },
  { id: '長野県', title: '長野県' },
  { id: '岐阜県', title: '岐阜県' },
  { id: '静岡県', title: '静岡県' },
  { id: '愛知県', title: '愛知県' },
  { id: '三重県', title: '三重県' },
  { id: '滋賀県', title: '滋賀県' },
  { id: '京都府', title: '京都府' },
  { id: '大阪府', title: '大阪府' },
  { id: '兵庫県', title: '兵庫県' },
  { id: '奈良県', title: '奈良県' },
  { id: '和歌山県', title: '和歌山県' },
  { id: '鳥取県', title: '鳥取県' },
  { id: '島根県', title: '島根県' },
  { id: '岡山県', title: '岡山県' },
  { id: '広島県', title: '広島県' },
  { id: '山口県', title: '山口県' },
  { id: '徳島県', title: '徳島県' },
  { id: '香川県', title: '香川県' },
  { id: '愛媛県', title: '愛媛県' },
  { id: '高知県', title: '高知県' },
  { id: '福岡県', title: '福岡県' },
  { id: '佐賀県', title: '佐賀県' },
  { id: '長崎県', title: '長崎県' },
  { id: '熊本県', title: '熊本県' },
  { id: '大分県', title: '大分県' },
  { id: '宮崎県', title: '宮崎県' },
  { id: '鹿児島県', title: '鹿児島県' },
  { id: '沖縄県', title: '沖縄県' },
];

const MAX_FOLDER_LEVEL = 9;

export default {
  API_USER_RESOURCE,
  API_ARTICLE_RESOURCE,
  API_FOLDER_RESOURCE,
  API_CATEGORY_RESOURCE,
  API_NEEDS_RESOURCE,
  API_TONE_RESOURCE,
  API_ZIPCODE_RESOURCE,
  DEFAULT_TITLE,
  RESOURCE_LOGIN_WP_ERR_403,
  RESOURCE_LOGIN_WP_ERR_500,
  TIME_OUT_AXIOS,
  ALL_STATUSES,
  ISSUE_STATUS_LIST,
  API_NEWSLETTER_RESOURCE,
  API_ISSUE_RESOURCE,
  API_PRODUCT_RESOURCE,
  API_WBCOIN_RESOURCE,
  API_WALLET_RESOURCE,
  API_TASK_RESOURCE,
  PUBLISH_DRAFT_STATUSES,
  ARTICLE_RELATION_CACHE_KEY,
  API_QUEUE_RESOURCE,
  API_NFT_RESOURCE,
  TYPE_DOWNLOAD,
  SOCIAL_NETWORK,
  PERMISSION_FACEBOOK,
  VERSION_GRAPH_API,
  TIME_OUT_STRIPE,
  STATUS_TASK,
  TASK_SITUATION_CREATE,
  TASK_SITUATION_EDIT,
  MEMBER_STATUS,
  ROLES_ORDER,
  ROLE_NONE,
  DISPLAY_ADS_OPTION,
  NFT_OPTION,
  PAID_FREE,
  CREATIVE_COMMONS,
  PREF_WITH_TITLE,
  ROLES_USER,
  MAX_FOLDER_LEVEL,
};
